import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TaskType } from 'src/api';

@Pipe({ name: 'typeEnum' })
export class TypeEnumPipe implements PipeTransform {
  private readonly translate = inject(TranslateService);

  static translate(value: any, translate: TranslateService): string {
    const type = Object.values(TaskType).find((t) => t === value);
    return type ? translate.instant(type) : '-';
  }

  transform(value: any): any {
    return TypeEnumPipe.translate(value, this.translate);
  }
}
